const actions = {
  // SALES ACTIONS
  LIST_ORDERS_BEGIN: 'LIST_ORDERS_BEGIN',
  LIST_ORDERS_SUCCESS: 'LIST_ORDERS_SUCCESS',
  LIST_ORDERS_ERR: 'LIST_ORDERS_ERR',

  ORDER_DETAILS_BEGIN: 'ORDER_DETAILS_BEGIN',
  ORDER_DETAILS_SUCCESS: 'ORDER_DETAILS_SUCCESS',
  ORDER_DETAILS_ERR: 'ORDER_DETAILS_ERR',

  CREATE_ORDER_BEGIN: 'CREATE_ORDER_BEGIN',
  CREATE_ORDER_SUCCESS: 'CREATE_ORDER_SUCCESS',
  CREATE_ORDER_ERR: 'CREATE_ORDER_ERR',

  ORDER_RESELL_BEGIN: 'ORDER_RESELL_BEGIN',
  ORDER_RESELL_SUCCESS: 'ORDER_RESELL_SUCCESS',
  ORDER_RESELL_ERR: 'ORDER_RESELL_ERR',

  ORDER_DOWNLOAD_BEGIN: 'ORDER_DOWNLOAD_BEGIN',
  ORDER_DOWNLOAD_SUCCESS: 'ORDER_DOWNLOAD_SUCCESS',
  ORDER_DOWNLOAD_ERR: 'ORDER_DOWNLOAD_ERR',

  listOrdersBegin: () => {
    return {
      type: actions.LIST_ORDERS_BEGIN,
    };
  },

  listOrdersSuccess: (data) => {
    return {
      type: actions.LIST_ORDERS_SUCCESS,
      data,
    };
  },

  listOrdersErr: (err) => {
    return {
      type: actions.LIST_ORDERS_ERR,
      err,
    };
  },

  getOrderDetailsBegin: () => {
    return {
      type: actions.ORDER_DETAILS_BEGIN,
    };
  },

  getOrderDetailsSuccess: (data) => {
    return {
      type: actions.ORDER_DETAILS_SUCCESS,
      data,
    };
  },

  getOrderDetailsErr: (err) => {
    return {
      type: actions.ORDER_DETAILS_ERR,
      err,
    };
  },

  createOrderBegin: () => {
    return {
      type: actions.CREATE_ORDER_BEGIN,
    };
  },

  createOrderSuccess: (data) => {
    return {
      type: actions.CREATE_ORDER_SUCCESS,
      data,
    };
  },

  createOrderErr: (err) => {
    return {
      type: actions.CREATE_ORDER_ERR,
      err,
    };
  },
  orderResellBegin: () => {
    return {
      type: actions.ORDER_RESELL_BEGIN,
    };
  },

  orderResellSuccess: (data) => {
    return {
      type: actions.ORDER_RESELL_SUCCESS,
      data,
    };
  },

  orderResellErr: (err) => {
    return {
      type: actions.ORDER_RESELL_ERR,
      err,
    };
  },
  orderDownloadBegin: () => {
    return {
      type: actions.ORDER_DOWNLOAD_BEGIN,
    };
  },

  orderDownloadSuccess: (data) => {
    return {
      type: actions.ORDER_DOWNLOAD_SUCCESS,
      data,
    };
  },

  orderDownloadErr: (err) => {
    return {
      type: actions.ORDER_DOWNLOAD_ERR,
      err,
    };
  },
};

export default actions;
